var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnologie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#a9d0e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.64,65.88c0,6.37-5.16,11.54-11.54,11.54s-11.54-5.17-11.54-11.54,5.16-11.54,11.54-11.54,11.54,5.16,11.54,11.54Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.41,70.27c-.32,1.16-.79,2.27-1.36,3.3l1.76,2.3-5.7,5.7-2.3-1.76c-1.04.57-2.14,1.04-3.3,1.37l-.37,2.86h-8.07l-.37-2.86c-1.16-.33-2.27-.79-3.3-1.37l-2.28,1.76-5.7-5.7,1.75-2.28c-.57-1.04-1.04-2.15-1.37-3.32l-2.86-.37v-8.06l2.86-.37c.33-1.16.79-2.27,1.36-3.3l-1.75-2.29,5.7-5.69,2.28,1.75c1.04-.57,2.14-1.04,3.3-1.37l.37-2.86h8.07l.38,2.86c1.16.33,2.27.79,3.3,1.37l2.29-1.75,5.7,5.69-1.77,2.3c.57,1.04,1.04,2.14,1.36,3.3l2.88.37v8.06l-2.87.37Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.22,62.41c5.07-1.98,8.66-6.91,8.66-12.68,0-7.51-6.09-13.6-13.61-13.6-5.67,0-10.55,3.49-12.58,8.43",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.09,67.22c.79-.3,1.55-.65,2.27-1.05l2.72,2.08,6.72-6.73-2.08-2.71c.68-1.22,1.22-2.52,1.61-3.89l3.38-.43v-9.51l-3.39-.43c-.38-1.36-.93-2.67-1.61-3.88l2.09-2.72-6.72-6.71-2.71,2.07c-1.22-.68-2.52-1.22-3.89-1.62l-.44-3.37h-9.52l-.43,3.37c-1.37.39-2.67.94-3.89,1.62l-2.69-2.07-6.73,6.71,2.07,2.71c-.34.63-.66,1.28-.94,1.96",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "66.04 83.12 80.94 83.12 80.94 75.6",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.04,83.12c0,1.23-.99,2.22-2.22,2.22s-2.22-.99-2.22-2.22.99-2.22,2.22-2.22,2.22.99,2.22,2.22Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.94,
    cy: 73.38,
    r: 2.22,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "39.6 31.9 31.14 31.9 31.14 39.42",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.6,31.9c0-1.23.99-2.22,2.22-2.22s2.22.99,2.22,2.22-.99,2.22-2.22,2.22-2.22-.99-2.22-2.22Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.92,41.64c0-1.23.99-2.22,2.22-2.22s2.22.99,2.22,2.22-.99,2.22-2.22,2.22-2.22-.99-2.22-2.22Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnologie);
export default __webpack_public_path__ + "static/media/technologie.390c96679c1478f749cdf41170499cdf.svg";
export { ForwardRef as ReactComponent };